import { Edit as EditIcon } from '@mui/icons-material';
import { Box, Button, Chip, IconButton, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';

const AdminPermissionsTable = ({ users, predefinedPermissions, onUpdatePermissions }) => {
    const [editingStates, setEditingStates] = useState(new Map());
    const [selectedPermissionsMap, setSelectedPermissionsMap] = useState(new Map());
    const [selectedRoleMap, setSelectedRoleMap] = useState(new Map());



const handleEditPermissions = (user) => {
    setEditingStates(new Map().set(user, true));
    setSelectedPermissionsMap(new Map().set(user, user.permissions ? [...user.permissions] : []));
    setSelectedRoleMap(new Map().set(user, user.role || 'user'));
};

const handleSavePermissions = (user) => {
    const permissions = selectedPermissionsMap.get(user) || [];
    const role = selectedRoleMap.get(user) || 'user';
    console.log(user)
    onUpdatePermissions(user.id, permissions, role);
    setEditingStates(prev => { 
      const newMap = new Map(prev); 
      newMap.set(user, false); 
      return newMap; 
    });
    setSelectedPermissionsMap(prev => { 
      const newMap = new Map(prev); 
      newMap.delete(user); 
      return newMap; 
    });
    setSelectedRoleMap(prev => { 
      const newMap = new Map(prev); 
      newMap.delete(user); 
      return newMap; 
    });
};

const handleCancelEdit = (user) => {
    setEditingStates(prev => { 
      const newMap = new Map(prev); 
      newMap.set(user, false); 
      return newMap; 
    });
    setSelectedPermissionsMap(prev => { 
      const newMap = new Map(prev); 
      newMap.delete(user); 
      return newMap; 
    });
    setSelectedRoleMap(prev => { 
      const newMap = new Map(prev); 
      newMap.delete(user); 
      return newMap; 
    });
};

return (
  <Table>
        <TableHead>
          <TableRow>
            <TableCell>User</TableCell>
            <TableCell>Id</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Current Permissions</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users?.map((user) => {
            const isEditing = editingStates.get(user) || false;
            const selectedPermissions = selectedPermissionsMap.get(user) || [];
            const selectedRole = selectedRoleMap.get(user) || user.role || 'user';
            return (
              <TableRow key={user.id}>
                <TableCell>
                  <Box>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {user?.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {user?.email}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>{user?.user_id}</TableCell>
                <TableCell>
                  {isEditing ? (
                    <Select
                      value={selectedRole}
                      onChange={(e) => {
                        setSelectedRoleMap(prev => {
                          const newMap = new Map(prev);
                          newMap.set(user, e.target.value);
                          return newMap;
                        });
                      }}
                      size="small"
                      sx={{ minWidth: 120 }}
                    >
                      <MenuItem value="user">User</MenuItem>
                      <MenuItem value="admin">Admin</MenuItem>
                      <MenuItem value="super_admin">Super Admin</MenuItem>
                    </Select>
                  ) : (
                    <Chip
                      size="small"
                      label={user?.role || 'user'}
                      sx={{
                        backgroundColor: user?.role === 'super_admin' ? 'error.main' : user?.role === 'admin' ? 'warning.main' : 'info.main',
                        color: '#fff',
                      }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {isEditing ? (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                      {selectedPermissions.map((permission) => (
                        <Chip
                          key={permission}
                          size="small"
                          label={permission}
                          sx={{
                            backgroundColor: 'earnpati.main',
                            color: '#fff',
                          }}
                          onDelete={() => {
                            setSelectedPermissionsMap(prev => {
                              const newMap = new Map(prev);
                              newMap.set(user, selectedPermissions.filter(p => p !== permission));
                              return newMap;
                            });
                          }}
                        />
                      ))}
                      <Select
                        value=""
                        onChange={(e) => {
                          const perm = e.target.value;
                          if (perm && !selectedPermissions.includes(perm)) {
                            setSelectedPermissionsMap(prev => {
                              const newMap = new Map(prev);
                              newMap.set(user, [...selectedPermissions, perm]);
                              return newMap;
                            });
                          }
                        }}
                        displayEmpty
                        size="small"
                        sx={{ minWidth: 120 }}
                      >
                        <MenuItem value="" disabled>Add permission</MenuItem>
                        {predefinedPermissions.filter(p => !selectedPermissions.includes(p)).map((permission) => (
                          <MenuItem key={permission} value={permission}>{permission}</MenuItem>
                        ))}
                      </Select>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {user?.permissions?.length > 0 ? (
                        user.permissions.map((permission) => (
                          <Chip
                            key={permission}
                            size="small"
                            label={permission}
                            sx={{
                              backgroundColor: 'earnpati.main',
                              color: '#fff',
                              mr: 0.5,
                            }}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          No permissions
                        </Typography>
                      )}
                    </Box>
                  )}
                </TableCell>

                <TableCell align="center">
                  {isEditing ? (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleSavePermissions(user)}
                      >
                        Save
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleCancelEdit(user)}
                      >
                        Cancel
                      </Button>
                    </Box>
                  ) : (
                    <Tooltip title="Edit Permissions">
                      <IconButton
                        size="small"
                        onClick={() => handleEditPermissions(user)}
                        color="secondary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
);
};

export default AdminPermissionsTable;
